import { UIHeading3, ArticleHeading3, Image } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './BuilderInfo.css';
import { IBuilder } from '../../../../types/project';

interface IBuilderInfoProps extends IBuilder {
  onClick(): void;
}

export const BuilderInfo: React.FC<IBuilderInfoProps> = ({ logo, url, name, onClick }) => {
  return (
    <div className={styles['info']}>
      <div className={styles['logo']}>
        <Image src={logo} width={48} height={48} objectFit="cover" />
      </div>
      <div>
        <UIHeading3>Другие проекты компании</UIHeading3>
        <a href={url} target="_blank" className={styles['company-link']} rel="noreferrer" onClick={onClick}>
          <ArticleHeading3 color="text-main-default">«{name}»</ArticleHeading3>
        </a>
      </div>
    </div>
  );
};
